import { computed, effect, signal } from "@preact/signals-react";
import { v4 as uuidv4 } from "uuid";
import { listTypeDatasets } from "../Common/Store/CommonSignals";

export const EmptyDataset = {
  id: "",
  datasetName: "",
  datasetDescription: "",
  datasetType: "",
  values: [
    {
      id: uuidv4(),
      value: "",
      filterValue: "",
    },
  ],
  columns: [],
  childTable: null,
  parentDataset: null,
  owner: "",
  sharedPermission: [],
  coOwners: [],
  tags: [],
};

export const EmptyUserGroupDataset = {
  id: "",
  datasetName: "",
  datasetDescription: "",
  datasetType: "User Group",
  values: [
    {
      id: uuidv4(),
      person: null,
    },
  ],
  columns: [],
  childTable: null,
  parentDataset: null,
  owner: "",
  sharedPermission: [],
  coOwners: [],
  tags: [],
};

export const datasetData = signal(getDatasetData());
//Gets the dataset data from local storage or returns an empty dataset
function getDatasetData() {
  const datasetData = localStorage.getItem("DATASET_DATA");
  return JSON.tryParse(datasetData, EmptyDataset);
}
//Saves the dataset data to local storage when it changes
effect(() => {
  localStorage.setItem("DATASET_DATA", JSON.stringify(datasetData.value));
});

export const parentDatasetName = computed(() =>
  listTypeDatasets.value
    ? listTypeDatasets.value.find(
        (parentDataset) => parentDataset.id === datasetData.value.parentDataset
      )?.datasetName
    : ""
);

export const isVisible = signal(false);
export const isSaving = signal(false);
export const datasetEditMode = signal("Visual");
export const showFileUpload = signal(false);
export const showParentDatasetSelection = signal(false);
export const skip = signal(0);
